module.exports = {
  returnDescricao: {
    FinalizacaoRelatorioBeneficiarios:
      'Finalização de Relatório de Beneficiários',
    AlteracaoListaStatusAguardandoDocumentos:
      'Alteração de Status de Lista Para Aguardando Documentos',
    AlteracaoListaStatusAguardandoDownload:
      'Alteração de Status de Lista Para Aguardando Download',
    AlteracaoListaStatusEmAnaliseDocumentacao:
      'Alteração de Status de Lista Para Em Análise de Documentação',
    AlteracaoListaStatusEmValidacao:
      'Alteração de Status de Lista Para Em Validação',
    AlteracaoListaStatusProcessadoErro:
      "Alteração de Status de Lista Para 'Processado Com Erro'",
    AlteracaoListaStatusErroValidacao:
      "Alteração de Status de Lista Para 'Erro de Validação'",
    AlteracaoListaStatusExcluida:
      "Alteração de Status de Lista Para 'Excluída'",
    AlteracaoListaStatusPendente:
      "Alteração de Status de Lista Para 'Pendente de Envio'",
    AlteracaoListaStatusPendenteProcessamento:
      "Alteração de Status de Lista Para 'Pendente de Processamento'",
    AlteracaoListaStatusProcessadoSucesso:
      "Alteração de Status de Lista Para 'Processado Com Sucesso'",
    AlteracaoListaStatusProcessadaParcialmente:
      "Alteração de Status de Lista Para 'Processada Parcialmente'",
    ErroGeracaoRelatorioBeneficiarios:
      'Erro na geração do relatório de beneficiários',
  },
  returnIdForName: {
    FinalizacaoRelatorioBeneficiarios: 1,
    AlteracaoListaStatusAguardandoDocumentos: 2,
    AlteracaoListaStatusAguardandoDownload: 3,
    AlteracaoListaStatusEmAnaliseDocumentacao: 4,
    AlteracaoListaStatusEmValidacao: 5,
    AlteracaoListaStatusProcessadoErro: 6,
    AlteracaoListaStatusErroValidacao: 7,
    AlteracaoListaStatusExcluida: 8,
    AlteracaoListaStatusPendente: 9,
    AlteracaoListaStatusPendenteProcessamento: 10,
    AlteracaoListaStatusProcessadoSucesso: 11,
    AlteracaoListaStatusProcessadaParcialmente: 13,
    ErroGeracaoRelatorioBeneficiarios: 14,
  },
  returnIdForDescription: {
    'Finalização de Relatório de Beneficiários': 1,
    'Alteração de Status de Lista Para Aguardando Documentos': 2,
    'Alteração de Status de Lista Para Aguardando Download': 3,
    'Alteração de Status de Lista Para Em Análise de Documentação': 4,
    'Alteração de Status de Lista Para Em Validação': 5,
    "Alteração de Status de Lista Para 'Processado Com Erro'": 6,
    "Alteração de Status de Lista Para 'Erro de Validação'": 7,
    "Alteração de Status de Lista Para 'Excluída'": 8,
    "Alteração de Status de Lista Para 'Pendente de Envio'": 9,
    "Alteração de Status de Lista Para 'Pendente de Processamento'": 10,
    "Alteração de Status de Lista Para 'Processado Com Sucesso'": 11,
    "Alteração de Status de Lista Para 'Processada Parcialmente'": 13,
    'Erro na geração do relatório de beneficiários': 14,
  },
  returnDescriptionPorId: {
    1: 'Finalização de Relatório de Beneficiários',
    2: 'Alteração de Status de Lista Para Aguardando Documentos',
    3: 'Alteração de Status de Lista Para Aguardando Download',
    4: 'Alteração de Status de Lista Para Em Análise de Documentação',
    5: 'Alteração de Status de Lista Para Em Validação',
    6: "Alteração de Status de Lista Para 'Processado Com Erro'",
    7: "Alteração de Status de Lista Para 'Erro de Validação'",
    8: "Alteração de Status de Lista Para 'Excluída'",
    9: "Alteração de Status de Lista Para 'Pendente de Envio'",
    10: "Alteração de Status de Lista Para 'Pendente de Processamento'",
    11: "Alteração de Status de Lista Para 'Processado Com Sucesso'",
    13: "Alteração de Status de Lista Para 'Processada Parcialmente'",
    14: 'Erro na geração do relatório de beneficiários',
  },
};
